// extracted by mini-css-extract-plugin
module.exports = {"container":"get-in-touch_container__puQ2e","title":"get-in-touch_title__8j5_h","subtitle":"get-in-touch_subtitle__41vJu"};